<template>
  <div class="loader">
    <img
      class="spinner"
      src="@/assets/images/element/spinner.png"
      alt="Spinner"
    />
    <img v-if="showLock" class="lock" src="@/assets/images/illustration/lock.svg" alt="Lock" />
  </div>
</template>

<script setup>
defineProps({
  showLock: {
    type: Boolean,
    default: true
  }
});
</script>
